import { useEffect, useMemo, useRef, useState } from "react";
import { useNotificationUtils } from "./NotificationElement";
export function useNotificationEventCallback(action) {
    var notificationElement = useNotificationUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.on, memoizedAction]);
    return data;
}
